"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactComponents = require("@ui-propulsion/react-components");
var _util = require("../../util");
var AddProviderButton = function AddProviderButton(_ref) {
  var disabled = _ref.disabled,
    tooltip = _ref.tooltip,
    onAddProvider = _ref.onAddProvider;
  if (!onAddProvider) return null;
  var bem = (0, _util.bemClass)('revisions-revisor');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: bem('add-provider')
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Button, {
    disabled: disabled,
    className: bem('add-provider-button'),
    variant: "tertiary",
    fullWidth: false,
    onClick: onAddProvider
  }, "Add Provider"), /*#__PURE__*/_react.default.createElement("span", {
    className: bem('tooltip-icon'),
    "data-tooltip": "Test Tooltip"
  }, "?"), /*#__PURE__*/_react.default.createElement("span", {
    className: bem('tooltip-message')
  }, tooltip));
};
AddProviderButton.propTypes = {
  disabled: _propTypes.default.bool,
  tooltip: _propTypes.default.string,
  onAddProvider: _propTypes.default.func
};
AddProviderButton.defaultProps = {
  disabled: false,
  tooltip: '',
  onAddProvider: null
};
var _default = AddProviderButton;
exports.default = _default;
